import React from 'react';

function BlackTitleText(props) {
    return (
        
             <p className='font_md'>{props.title}</p>
     
    );
}

export default BlackTitleText;